module.exports = __webpack_public_path__ + "static/media/icon-user.553f82d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-user.svg
// module id = 558
// module chunks = 0